// Enrollment view types
export const EVENT_ENROLLMENT_FROM_SEGMENTATION_FILTERS = 'EVENT_ENROLLMENT_FROM_SEGMENTATION_FILTERS';
export const LIST_ENROLLMENT = 'LIST_ENROLLMENT';
export const SELECTABLE_ENROLLMENT = 'SELECTABLE_ENROLLMENT';
export const SCHEDULED_ENROLLMENT = 'SCHEDULED_ENROLLMENT';

// TODO: Add template enrollment here when we consolidate
// export const TEMPLATE_ENROLLMENT = 'TEMPLATE_ENROLLMENT';